import {
  addDoc,
  collection,
  getDoc,
  limit,
  onSnapshot,
  orderBy,
  query,
  setDoc,
  updateDoc,
  where,
  doc,
  startAfter,
  getDocs
} from 'firebase/firestore';
import { firebaseDB } from '../../config/firebase';

let db = firebaseDB;

export const firebasePathToRef = async (target, docId) => {
  try {
    if (docId) {
      return doc(db, target, docId)
    }
    return collection(db, target)
  }
  catch (err) {
    return {};
  }
}

// export const handleQueryFirebase = async (target, params = {}) => {
//   let dbRef = collection(db, target);
//   if (params.whereList) {
//     params.whereList.forEach((e) => {
//       dbRef = query(dbRef, where(e[0], e[1], e[2]));
//     });
//   } else if (params.where) {
//     dbRef = query(
//       dbRef,
//       where(params.where[0], params.where[1], params.where[2])
//     );
//   } else if (params.orderBy) {
//     const orderType = params.orderType ? params.orderType : 'desc';
//     dbRef = query(dbRef, orderBy(params.orderBy, orderType));
//   }
//   if (params.lastRef && params.lastDocRef) {
//     const lastDocRef = await firebasePathToRef(params.lastRef, params.lastDocRef);
//     const lastDocSnap = await lastDocRef.get();
//     dbRef = dbRef.startAfter(lastDocSnap);
//   }
//   if (params.maxLength) {
//     dbRef = query(dbRef, limit(params.maxLength));
//   }
//   if (params.callType) {
//     switch (params.callType) {
//       case 'onSnapshot':
//         return onSnapshot(dbRef, params.callbackSuccess);
//       default:
//         return onSnapshot(dbRef, params.callbackSuccess);
//     }
//   } else {
//     return getDoc(dbRef);
//   }
// };

export const handleQueryFirebase = async (target, params = {}) => {
  let dbRef = collection(db, target);
  const queryConstraints = [];

  if (params.whereList) {
    params.whereList.forEach((e) => {
      queryConstraints.push(where(e[0], e[1], e[2]));
    });
  } else if (params.where) {
    queryConstraints.push(where(params.where[0], params.where[1], params.where[2]));
  }

  if (params.orderBy) {
    const orderType = params.orderType ? params.orderType : 'desc';
    queryConstraints.push(orderBy(params.orderBy, orderType));
  }

  if (params.lastRef && params.lastDocRef) {
    // Convert path to doc ref
    const lastDocSnap = await getDoc(doc(db, params.lastRef, params.lastDocRef));
    if (lastDocSnap.exists()) {
      queryConstraints.push(startAfter(lastDocSnap));
    }
  }

  if (params.maxLength) {
    queryConstraints.push(limit(params.maxLength));
  }

  const finalQuery = query(dbRef, ...queryConstraints);

  if (params.callType === 'onSnapshot') {
    return onSnapshot(finalQuery, params.callbackSuccess);
  } else {
    return getDocs(finalQuery); // getDocs, not getDoc for queries
  }
};

export const handleUpdateFirebase = (target, docId, params) => {
  return updateDoc(doc(db, target, docId), params)
    .then(() => {
      console.log(`${target}/${docId} Document successfully updated!`, params);
    })
    .catch((err) => {
      console.error(
        `${target}/${docId} ${params} Error updating document: ${err}`,
        params
      );
    });
};

// export const handleSetFirebase = (target, doc, params) => {
export const handleSetFirebase = (target, docId, params) => {
  return setDoc(doc(db, target, docId), params)
    .then(() => {
      console.log(`${target}/${docId} Document successfully set!`, params);
    })
    .catch(err => {
      console.error(`${target}/${docId} ${params} Error updating document: ${err}`, params);
    });
}

export const handleAddFirebase = async (target, params) => {
  return addDoc(collection(db, target), params)
    .then((res) => {
      console.log(`${target} Document successfully added!`, params, res);
      return res
    })
    .catch(err => {
      console.error(`${target} ${params} Error adding document: ${err}`, params);
    });
}

